import Reveal from "../components/Reveal";
import classes from "./PageShell.module.css";

const Privacy = () => {
  return (
    <>
      <main className={classes.page}>
        <Reveal as="section" className={classes.card}>
          <p className={classes.eyebrow}>Privacy</p>
          <h1>Privacy Policy for &quot;It&apos;s Time&quot;</h1>
          <div className={classes.content}>
            <h2>Introduction</h2>
            <p>
              It&apos;s Time is a reminder app built to help manage tasks with a
              simple, low-friction experience. This policy explains how data is
              handled when using the app.
            </p>
            <h2>Information Collection and Use</h2>
            <p>
              The app does not collect personal data. Reminder information stays
              on the device and is not sent to servers or third parties. The app
              also does not use cookies or tracking technologies.
            </p>
            <h2>Data Storage and Security</h2>
            <p>
              All reminder content is stored locally on the user&apos;s device.
              Because the data remains local, device-level security is the main
              layer of protection.
            </p>
            <h2>Children&apos;s Privacy</h2>
            <p>
              The app does not knowingly collect information from children under
              13. Since no personal data is collected, the app is suitable for a
              broad audience.
            </p>
            <h2>Policy Updates</h2>
            <p>
              This privacy policy may be updated over time. Any revisions will
              be posted on this page.
            </p>
            <h2>Contact</h2>
            <p>
              Questions about this policy can be sent to{" "}
              <a href="mailto:achenloveswork@gmail.com">achenloveswork@gmail.com</a>.
            </p>
          </div>
        </Reveal>
      </main>
    </>
  );
};

export default Privacy;
